// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"9d3eda69","209":"d8f94034"}[chunkId] + ".chunk.js";
};